import { ThemeAction } from '../actions/themeActions';
import { AppTheme, DARK_THEME, LIGHT_THEME, PREFERRED_THEME_LOCAL_STORAGE_KEY } from '../models/theme';

export const themeReducer = (state: AppTheme, action: ThemeAction): AppTheme => {
    switch (action.type) {
        case 'SWITCH_THEME':
            const newTheme = state === LIGHT_THEME ? DARK_THEME : LIGHT_THEME;
            localStorage.setItem(PREFERRED_THEME_LOCAL_STORAGE_KEY, newTheme);
            return newTheme;
        default:
            return state;
    }
};
